const RealizeTableCell = window.TableCell;

export default class TableCell extends RealizeTableCell {

	constructor(props) {
		super(props);		

		this.numberValue = this.decimalValue = this.currencyValue = this.formatNumericValue;		
	}

	formatNumericValue(value) {
		value = parseFloat(value);
		if (isNaN(value)) return '';
		return value;
	}	
}
